/* Throne & Threads â custom behaviour: cursor ring, lineup filters, quick add */
(function () {
  /* ---------- cursor ring ---------- */
  if (window.matchMedia('(hover:hover)').matches) {
    var ring = document.createElement('div');
    ring.className = 'tt-ring';
    document.body.appendChild(ring);
    var rx = 0, ry = 0, tx = 0, ty = 0;
    window.addEventListener('mousemove', function (e) { tx = e.clientX; ty = e.clientY; ring.classList.add('is-on'); });
    window.addEventListener('mouseout', function () { ring.classList.remove('is-on'); });
    document.addEventListener('mouseover', function (e) {
      ring.classList.toggle('is-big', !!(e.target.closest && e.target.closest('a,button,.tt-card')));
    });
    (function loop() {
      rx += (tx - rx) * 0.18; ry += (ty - ry) * 0.18;
      ring.style.transform = 'translate(' + rx + 'px,' + ry + 'px) translate(-50%,-50%)';
      requestAnimationFrame(loop);
    })();
  }

  /* ---------- lineup filters ---------- */
  document.querySelectorAll('[data-tt-lineup]').forEach(function (root) {
    var cat = 'all', brand = 'all';
    var cards = root.querySelectorAll('.tt-card');

    function apply() {
      cards.forEach(function (c) {
        var okCat = cat === 'all' || (c.dataset.cats || '').split('|').indexOf(cat) > -1;
        var okBrand = brand === 'all' || c.dataset.vendor === brand;
        c.classList.toggle('is-hidden', !(okCat && okBrand));
      });
      var empty = root.querySelector('[data-tt-empty]');
      if (empty) {
        var visible = root.querySelectorAll('.tt-card:not(.is-hidden)').length;
        empty.style.display = visible ? 'none' : 'block';
      }
    }
    root.querySelectorAll('[data-tt-cat]').forEach(function (b) {
      b.addEventListener('click', function () {
        cat = b.dataset.ttCat;
        root.querySelectorAll('[data-tt-cat]').forEach(function (x) { x.setAttribute('aria-pressed', x === b); });
        apply();
      });
    });
    root.querySelectorAll('[data-tt-brand]').forEach(function (b) {
      b.addEventListener('click', function () {
        brand = b.dataset.ttBrand;
        root.querySelectorAll('[data-tt-brand]').forEach(function (x) { x.setAttribute('aria-pressed', x === b); });
        apply();
      });
    });
  });

  /* ---------- quick add ---------- */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('[data-tt-quick]');
    if (trigger) {
      e.preventDefault();
      var pop = trigger.parentElement.querySelector('.tt-sizes');
      document.querySelectorAll('.tt-sizes.is-open').forEach(function (el) { if (el !== pop) el.classList.remove('is-open'); });
      if (pop) pop.classList.toggle('is-open');
      return;
    }
    if (!(e.target.closest && e.target.closest('.tt-sizes'))) {
      document.querySelectorAll('.tt-sizes.is-open').forEach(function (el) { el.classList.remove('is-open'); });
    }
  });

  /* ---------- mega menu panel + scrim ----------
     Panel and scrim stay put inside <header-menu> (not relocated to <body>):
     Dawn's HeaderMenu auto-closes on focusout via `this.contains(activeElement)`,
     so moving the panel outside that subtree made every click on a menu link
     register as an "outside click" and slam the menu shut before navigation.
     position:fixed on .tt-mega already anchors to the viewport regardless of
     DOM nesting (no ancestor here sets transform/filter/perspective/contain),
     so keeping it in place costs nothing and fixes the broken links.

     Top offset is computed here instead of trusting Dawn's --header-height
     custom property: that variable is set from `.section-header.offsetHeight`,
     which is only the main header row â it does NOT include the announcement
     bar section rendered above it. Anchoring to var(--header-height) alone
     put the panel's top edge inside the header itself, and since the panel's
     z-index is higher than the header's, it painted over the header content
     (hiding the wordmark) instead of starting below it. Reading the real
     header block's own getBoundingClientRect().bottom each time the menu
     opens accounts for the announcement bar, sticky/hidden state, and any
     future header height changes, with no CSS var involved. */
  document.querySelectorAll('[data-tt-mega-scrim]').forEach(function (scrim) {
    var details = scrim.closest('details');
    if (!details) return;
    var panel = details.querySelector('.tt-mega');
    var headerBlock = document.querySelector('.section-header') || document.querySelector('.header-wrapper');

    function positionPanel() {
      if (!panel || !headerBlock) return;
      var top = Math.round(headerBlock.getBoundingClientRect().bottom);
      panel.style.top = top + 'px';
      panel.style.maxHeight = 'calc(100vh - ' + top + 'px)';
    }

    function sync() {
      var isOpen = details.open;
      if (isOpen) positionPanel();
      scrim.classList.toggle('is-open', isOpen);
      if (panel) panel.classList.toggle('is-open', isOpen);
    }
    details.addEventListener('toggle', sync);
    window.addEventListener('resize', function () { if (details.open) positionPanel(); });
    scrim.addEventListener('click', function () {
      details.removeAttribute('open');
    });
  });

  /* ---------- quick view modal ---------- */
  var modal = document.getElementById('tt-modal');
  var scrim = document.getElementById('tt-scrim');
  if (modal && scrim) {
    var mShot = document.getElementById('tt-modal-shot');
    var mBrand = document.getElementById('tt-modal-brand');
    var mName = document.getElementById('tt-modal-name');
    var mPrice = document.getElementById('tt-modal-price');
    var mDesc = document.getElementById('tt-modal-desc');
    var mSpecs = document.getElementById('tt-modal-specs');
    var mSizes = document.getElementById('tt-modal-sizes');
    var mAdd = document.getElementById('tt-modal-add');
    var mVariantInput = document.getElementById('tt-modal-variant-id');

    function esc(s) {
      return (s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }

    function closeModal() {
      modal.classList.remove('is-open');
      scrim.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
    }

    function openModal(data) {
      mShot.innerHTML = data.image
        ? '<img src="' + esc(data.image) + '" alt="' + esc(data.name) + '">'
        : '<span class="tt-modal__mark">' + esc((data.brand || '').slice(0, 2).toUpperCase()) + '</span>';
      mBrand.textContent = data.brand + (data.sku ? ' Â· ' + data.sku : '');
      mName.textContent = data.name;
      mPrice.innerHTML = esc(data.price) + (data.comparePrice ? ' <s>' + esc(data.comparePrice) + '</s>' : '');
      mDesc.textContent = data.desc;
      mSpecs.innerHTML = (data.specs || []).map(function (s) {
        return '<li><span class="k">' + esc(s[0]) + '</span><span class="v">' + esc(s[1]) + '</span></li>';
      }).join('');
      mSizes.innerHTML = (data.variants || []).map(function (v) {
        return '<button type="button" data-variant-id="' + v.id + '" ' + (v.available ? '' : 'disabled') + ' aria-pressed="false">' + esc(v.size) + '</button>';
      }).join('');
      mVariantInput.value = '';
      mAdd.disabled = true;
      modal.classList.add('is-open');
      scrim.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
    }

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest && e.target.closest('[data-tt-view]');
      if (trigger) {
        var card = trigger.closest('.tt-card');
        var script = card && card.querySelector('[data-tt-product-json]');
        if (script) {
          try { openModal(JSON.parse(script.textContent)); } catch (err) {}
        }
        return;
      }
      if (e.target.closest && e.target.closest('[data-tt-modal-close]')) {
        closeModal();
        return;
      }
      var sizeBtn = e.target.closest && e.target.closest('#tt-modal-sizes button');
      if (sizeBtn && !sizeBtn.disabled) {
        mVariantInput.value = sizeBtn.dataset.variantId;
        mAdd.disabled = false;
        Array.prototype.forEach.call(mSizes.querySelectorAll('button'), function (b) {
          b.setAttribute('aria-pressed', b === sizeBtn ? 'true' : 'false');
        });
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModal();
    });
  }
})();

/* ---------- sticky add-to-cart (product pages) ---------- */
(function () {
  var bar = document.getElementById('tt-sticky-atc');
  if (!bar) return;
  var form =
    document.querySelector('form.product-form[action*="/cart/add"]') ||
    document.querySelector('form[action*="/cart/add"]');
  if (!form) {
    bar.remove();
    return;
  }
  var submitBtn = form.querySelector('[name="add"]');
  var watchTarget = form.querySelector('.product-form__buttons') || submitBtn;
  if (!submitBtn || !watchTarget) {
    bar.remove();
    return;
  }
  var variantEl = bar.querySelector('[data-tt-sticky-variant]');
  var sepEl = bar.querySelector('[data-tt-sticky-sep]');
  var priceEl = bar.querySelector('[data-tt-sticky-price]');
  var addBtn = bar.querySelector('[data-tt-sticky-add]');
  var handle = bar.getAttribute('data-handle');
  var variants = [];

  function fmt(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function currentVariantId() {
    var input = form.querySelector('input[name="id"]');
    return input ? input.value : null;
  }

  function refresh() {
    var vid = currentVariantId();
    var v = null;
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === String(vid)) {
        v = variants[i];
        break;
      }
    }
    if (v) {
      var showVariant = v.title && v.title !== 'Default Title';
      variantEl.textContent = showVariant ? v.title : '';
      variantEl.style.display = showVariant ? '' : 'none';
      if (sepEl) sepEl.style.display = showVariant ? '' : 'none';
      priceEl.textContent = fmt(v.price);
    }
    addBtn.disabled = submitBtn.disabled;
    var label = (submitBtn.textContent || '').trim();
    if (label) addBtn.textContent = label;
  }

  addBtn.addEventListener('click', function () {
    if (!addBtn.disabled) submitBtn.click();
  });

  form.addEventListener('change', refresh);

  if (handle) {
    fetch('/products/' + handle + '.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (p) {
        variants = p.variants || [];
        refresh();
      })
      .catch(function () {});
  }

  bar.hidden = false;
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(
      function (entries) {
        var show = !entries[0].isIntersecting;
        bar.classList.toggle('is-visible', show);
        document.body.classList.toggle('has-tt-sticky', show);
      },
      { threshold: 0 }
    );
    io.observe(watchTarget);
  } else {
    bar.classList.add('is-visible');
  }
  refresh();
})();

/* ---------- cart drawer cross-sell quick add ---------- */
document.addEventListener('click', function (e) {
  var btn = e.target.closest && e.target.closest('[data-tt-xsell-add]');
  if (!btn || btn.disabled) return;
  e.preventDefault();
  btn.disabled = true;
  var label = btn.textContent;
  btn.textContent = 'Adding...';
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({
      items: [{ id: btn.getAttribute('data-tt-xsell-add'), quantity: 1 }],
      sections: ['cart-drawer', 'cart-icon-bubble'],
    }),
  })
    .then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    })
    .then(function (state) {
      ['cart-drawer', 'cart-icon-bubble'].forEach(function (sid) {
        var html = state.sections && state.sections[sid];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        if (sid === 'cart-drawer') {
          var fresh = doc.querySelector('#CartDrawer');
          var cur = document.querySelector('#CartDrawer');
          if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        } else {
          var freshB = doc.querySelector('.shopify-section');
          var curB = document.getElementById('cart-icon-bubble');
          if (freshB && curB) curB.innerHTML = freshB.innerHTML;
        }
      });
    })
    .catch(function () {
      btn.textContent = label;
      btn.disabled = false;
    });
});
